import { combineReducers } from "redux";
import form from "./form";
import submit from "./submit";

const rootReducer = combineReducers({
  form,
  submit,
});

export default rootReducer;
